import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type Props = {
	label: string;
};

export const DetailCard: FC<PropsWithChildren<Props>> = ({
	label,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack>
			<Typography variant="sectionLabel">{label}</Typography>
			<Stack bgcolor={theme.palette.background.paper}>{children}</Stack>
		</Stack>
	);
};
